// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".memoGroup article.tableBox .listTable .tableWrap table tbody tr td.content{color:#636368;font-weight:400;font-size:14px!important}.iconTitleBox{border:unset}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
